define('views/blocks/CartExtraPriceView',['jquery', 'underscore', 'backbone', 'app', 'router', 'SubView', 'template!blocks/cart/extraprice', 'InternalLinkView'],
    function ($, _, Backbone, app, router, SubView, extrapriceTemplate, InternalLinkView) {

    return Backbone.View.extend(SubView).extend({
        initialize: function () {

            var view = this, cart = app.getCart();
            view.subviews = [];

            view.listenTo(cart, 'change', view.render);
            view.render();
        },

        render: function () {

            var view = this,
                t = extrapriceTemplate({
                cart: app.getCart()
            });

            view.$el.html(t);

            InternalLinkView.initializeLinksOfView(view);
            view.delegateEvents();
        },
    });
});
